import { render, staticRenderFns } from "./TrainerForm.vue?vue&type=template&id=7e454256&"
import script from "./TrainerForm.vue?vue&type=script&lang=js&"
export * from "./TrainerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TrainerForm.vue"
export default component.exports